export default {
  allowedOrigins: (state) => state.betgamesIframeUrlData.providerHomePage,
};
